import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';

const GlobalSidebarItem = ({ icon, title, badge, isSelected = false, onClick, className = '' }) => {
  const renderIcon = () => {
    if (icon && PhosphorIcons[icon]) {
      return React.createElement(PhosphorIcons[icon], {
        size: 18,
        color: isSelected ? 'var(--q3-neutral-default_inverted)' : 'var(--q3-neutral-default)',
      });
    }
    return null;
  };

  return (
    <button
      onClick={onClick}
      className={`group flex mb-2 items-center justify-between px-4 h-11 text-sm font-medium leading-normal transition-all duration-200 cursor-pointer
        ${
          isSelected
            ? 'bg-[var(--q3-neutral-default)] text-[var(--q3-neutral-default_inverted)]'
            : 'bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] hover:!bg-[var(--q3-surface-dimmer)]'
        }
        border border-transparent rounded-[12px] min-h-12 overflow-hidden ${className}`}
    >
      <div className="flex items-center gap-4 truncate">
        {icon && <div className="transition-transform duration-200 group-hover:scale-105">{renderIcon()}</div>}
        <span className="truncate">{title}</span>
      </div>

      <div className="flex items-center gap-1">
        {badge && (
          <span className="bg-[var(--q3-danger-normal)] text-white text-[10px] px-2 py-[2px] rounded-full font-semibold">
            {badge}
          </span>
        )}
        <PhosphorIcons.CaretRightIcon
          size={14}
          weight="bold"
          className="transition-transform duration-200 transform group-hover:translate-x-1 ml-2"
        />
      </div>
    </button>
  );
};

export default GlobalSidebarItem;
